import React, { useEffect, useState } from "react";
import logo from "../assets/img/YOD Business Solutions Logo-Red.png";

const Navbar = () => {

  const [scrolled, setScrolled] = useState(false);

useEffect(() => {
  const handleScroll = () => {
    setScrolled(window.scrollY > 50);
  };
  window.addEventListener("scroll", handleScroll);
  return () => window.removeEventListener("scroll", handleScroll);
}, []);

  return (
    <>
      {/* Topbar */}
      <div className="container-fluid bg-primary px-5 d-none d-lg-block">
        <div className="row gx-0 align-items-center">
          <div className="col-lg-5 text-center text-lg-start mb-lg-0">
            <div className="d-flex">
              <a href="mailto:info@yodbusiness.com" className="text-muted me-4">
                <i className="fas fa-envelope text-secondary me-2"></i>info@yodbusiness.com
              </a>
              <a href="tel:+251909434470" className="text-muted me-0">
                <i className="fas fa-phone-alt text-secondary me-2"></i>+251 909 434470, +251 913 897665
              </a>
            </div>
          </div>
          <div className="col-lg-3 text-center mb-2 mb-lg-0">
            <div className="d-inline-flex align-items-center" style={{ height: 45 }}>
              <a className="btn btn-sm btn-outline-light btn-square rounded-circle me-2" href="#"><i className="fab fa-twitter fw-normal text-secondary"></i></a>
              <a className="btn btn-sm btn-outline-light btn-square rounded-circle me-2" href="#"><i className="fab fa-facebook-f fw-normal text-secondary"></i></a>
              <a className="btn btn-sm btn-outline-light btn-square rounded-circle me-2" href="#"><i className="fab fa-linkedin-in fw-normal text-secondary"></i></a>
              <a className="btn btn-sm btn-outline-light btn-square rounded-circle me-2" href="#"><i className="fab fa-instagram fw-normal text-secondary"></i></a>
              <a className="btn btn-sm btn-outline-light btn-square rounded-circle" href="#"><i className="fab fa-youtube fw-normal text-secondary"></i></a>
            </div>
          </div>
        </div>
      </div>

      {/* Navbar */}
      <div className="container-fluid nav-bar p-0">
        <nav className="navbar navbar-expand-lg navbar-light bg-white px-4 px-lg-5 py-3 py-lg-0">
          <a href="/" className="navbar-brand p-0">
            <h1 className="display-5 text-secondary m-0">
              <img src={logo} alt="YOD Logo" className="img-fluid" />
            </h1>
          </a>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
            <span className="fa fa-bars"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarCollapse">
            <div className="navbar-nav ms-auto py-0">
              <a href="/" className="nav-item nav-link active">Home</a>
              <a href="/about" className="nav-item nav-link">About</a>
              <a href="/service" className="nav-item nav-link">Services</a>
              <a href="/events" className="nav-item nav-link">Event And News</a>
              <a href="/contact" className="nav-item nav-link">Contact</a>
            </div>
           
          </div>
        </nav>
      </div>
    </>
  );
};

export default Navbar;
